import { IConfig } from '@cian/config/shared';
import { createSelector } from '@reduxjs/toolkit';
import { FDealType, FOfferType, isAvailable } from '../../../../packages/JsonQuery';
import { selectIsSuburbanListing, selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectLocation } from 'shared/selectors/location';
import { getRegionId } from 'shared/utils/geo';

export const selectWithNeighborsVisible = (config: IConfig) =>
  createSelector(
    [selectIsSuburbanListing, selectLocation, selectJsonQuery],
    (isSuburbanListing, currentLocation, jsonQuery) => {
      const isMainRegions = currentLocation === 'moscow_mo' || currentLocation === 'spb_lo';

      const offerType = config.get<FOfferType>('neighbors.availableOfferType') || FOfferType.Any;
      const isAvailableOfferType = isAvailable(FDealType.Any, offerType)(jsonQuery);

      const regionsMap = config.get<Record<string, string>>('Audience.WithNeighborsFilter.Regions') || {};
      const includedRegions: number[] = Object.keys(regionsMap)
        .map(regionString => parseInt(regionString, 10))
        .filter(Boolean);
      const regionId = getRegionId(currentLocation);
      const isRegionIncluded = includedRegions.includes(regionId);

      return (
        !isMainRegions &&
        isAvailableOfferType &&
        Boolean(currentLocation.hasNeighbors) &&
        (isSuburbanListing || isRegionIncluded)
      );
    },
  );
